import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-5 14h-2V9h-2V7h4z"></path>
  </>,
  'LooksOne',
)
